/* Copyright (c) 2020-present CloudIO Inc */

import { useStateXAtomValue, useStateXSelector } from '@cloudio-saas/statex';
import { developerModeAtom, floatingSidebarsAtom } from 'designer/atoms';
import React, { memo } from 'react';
import useUser from 'root/useUser';
import {
  pinnedSidebarWidthSelector,
  sidebarLocationOptionAtom,
  sidebarWidthSelector,
} from 'utils/state';

export function usePanelWidth(appUid: string) {
  if (!appUid) {
    throw new Error('Missing appUid in usePanelWidth!');
  }
  const sidebarRight = useStateXAtomValue(sidebarLocationOptionAtom);
  const { userName } = useUser();

  const floatingSidebars = useStateXAtomValue(floatingSidebarsAtom, {
    params: { userName },
  });
  let sidebarWidth = useStateXSelector(sidebarWidthSelector, {
    params: { userName, appUid },
  });
  let pinnedSidebarWidth = useStateXSelector(pinnedSidebarWidthSelector, {
    params: { userName, appUid },
  });
  // const pinnedSidebarPanel = useStateXSelector(
  //   activePinnedSidebarPanelSelector,
  //   {
  //     params: { userName },
  //   },
  // );
  // let activeSidebarPanel = useStateXSelector(activeSidebarPanelSelector);
  // if (activeSidebarPanel === pinnedSidebarPanel) {
  //   activeSidebarPanel = '';
  // }
  if (sidebarRight) {
    const temp = pinnedSidebarWidth;
    pinnedSidebarWidth = sidebarWidth;
    sidebarWidth = temp;
  }
  return { sidebarRight, floatingSidebars, sidebarWidth, pinnedSidebarWidth };
}

function Float({
  appUid,
  children,
}: {
  appUid: string;
  children: React.ReactElement | null;
}): React.ReactElement | null {
  const developerMode = useStateXAtomValue(developerModeAtom, {
    params: { appUid },
  });

  const { floatingSidebars, sidebarWidth, pinnedSidebarWidth } =
    usePanelWidth(appUid);

  return developerMode ? (
    <>
      {floatingSidebars ? null : (
        <div
          className="sidebar-spacer"
          style={{
            minWidth: sidebarWidth,
            maxWidth: sidebarWidth,
            height: '100%',
            display: 'block',
            flex: 0,
          }}
        />
      )}
      {children}
      {floatingSidebars ? null : (
        <div
          className="pinned-sidebar-spacer"
          style={{
            minWidth: pinnedSidebarWidth,
            maxWidth: pinnedSidebarWidth,
            display: 'block',
            height: '100%',
            flex: 0,
          }}
        />
      )}
    </>
  ) : (
    children
  );
}

export default memo(Float);
